import { render, staticRenderFns } from "./ProductListings.vue?vue&type=template&id=7ddbd458&scoped=true&"
import script from "./ProductListings.vue?vue&type=script&lang=js&"
export * from "./ProductListings.vue?vue&type=script&lang=js&"
import style0 from "./ProductListings.vue?vue&type=style&index=0&id=7ddbd458&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddbd458",
  null
  
)

export default component.exports